import Box from '@mui/material/Box';
import { Navigate, Outlet } from 'react-router-dom';
import React, { FC } from 'react';
import { useAuth } from 'utils/contexts/auth-context';

const PublicLayout: FC = () => {
  const { loading, isLoggedIn } = useAuth();

  return !loading && isLoggedIn ? (
    <Navigate to='/' replace />
  ) : (
    <Box
      sx={{
        bgcolor: 'background.default',
        minHeight: '100%',
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
      }}
    >
      <Outlet />
    </Box>
  );
};

export default PublicLayout;
